/**
 * Module-level open/close state for the session-changed modal.
 *
 * The SDK response interceptor (main.tsx) opens the modal from outside the
 * React tree on 412 session_mismatch, so the trigger has to be a plain
 * function rather than a hook. The `SessionChangedModal` component
 * subscribes to this state via `useSyncExternalStore`.
 *
 * Background: SUP-3373.
 */

/**
 * Code literal that identifies a session-mismatch 412 vs any other 412
 * (e.g. ETag/precondition failures that might be introduced later). Must
 * match ``SESSION_MISMATCH_CODE`` in
 * ``supplyco_api/src/services/permissions/authentication.py``. Once
 * ``just gen api-types`` runs after this PR, the generated SDK exposes
 * the same literal as ``SessionMismatchResponse['detail']['code']``;
 * this constant can be replaced by a type-only import at that point.
 */
export const SESSION_MISMATCH_CODE = 'session_mismatch' as const

let isOpen = false
const listeners = new Set<() => void>()

function emit(): void {
  for (const listener of listeners) {
    listener()
  }
}

export function openSessionChangedModal(): void {
  if (isOpen) {
    return
  }
  isOpen = true
  emit()
}

export function subscribeSessionChanged(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function getSessionChangedSnapshot(): boolean {
  return isOpen
}

export function getSessionChangedServerSnapshot(): boolean {
  return false
}
